export default "<p>sms-services works!</p>\r\n";